/*
 *
 * Subscription constants
 *
 */

export const SET_SUBSCRIPTION_ACCOUNT_LIST = 'app/Subscription/SET_SUBSCRIPTION_ACCOUNT_LIST';
export const SET_SUBSCRIPTION_TEAM_LIST = 'app/Subscription/SET_SUBSCRIPTION_TEAM_LIST';

